import { Fragment } from 'react';

import { renderSanityBlock } from '@/components/blocks';

export const AbBlocksContainer = ({ blocks, extraProps }) => {
  return blocks.map((block) => (
    <Fragment key={block._id}>{renderSanityBlock(block, extraProps)}</Fragment>
  ));
};
